module.exports = __webpack_public_path__ + "img/leveler-5-off.2df454af.png";